export default __webpack_public_path__ + "img/c433d33c9ce93772f08628c1cb5928c9.svg";